import { render, staticRenderFns } from "./DetachBlockModal.vue?vue&type=template&id=5cc60878&scoped=true"
import script from "./DetachBlockModal.vue?vue&type=script&lang=js"
export * from "./DetachBlockModal.vue?vue&type=script&lang=js"
import style0 from "./DetachBlockModal.vue?vue&type=style&index=0&id=5cc60878&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc60878",
  null
  
)

export default component.exports